export function setReactiveStateValue(storeObject, property, value)
{
	if (typeof storeObject[property] === 'undefined')
	{
		Vue.set(storeObject, property, value);
	}
	else
	{
		storeObject[property] = value;
	}
}

export function simpleEmailValidation(email){
	const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
	return re.test(String(email).toLowerCase());
}

export function validateGenericInput(map, value)
{
	if (map.required === true)
	{
		if(value === '' || (typeof map.type !== 'undefined' && map.type === 'number' && Number(value) === 0))
			return 'mustBeDefined';
	}
	
	if (value !== '')
	{
		if (typeof map.type !== 'undefined')
		{
			if (map.type === 'email')
			{
				if (simpleEmailValidation(value) === false)
				{
					return 'notAnEmail';
				}
			}
		}
		
		if (typeof map.minLength !== 'undefined')
		{
			if (value.toString().length < map.minLength)
			{
				return 'tooShort';
			}
		}
		else if(typeof map.requiredLength !== 'undefined')
		{
			if (value.toString().length !== map.requiredLength)
			{
				return 'mustBe'+map.requiredLength+'Characters';
			}
		}
	}
	
	return false;
}
